import { useQuery } from '@tanstack/react-query';
import { estimateBoqLinksService } from '../services/estimateBoqLinks.service';

export function useEstimateBoqLinks(estimateId?: string) {
  const query = useQuery({
    queryKey: ['estimates', 'boq-links', estimateId],
    queryFn: () => estimateBoqLinksService.getByEstimateId(estimateId!),
    enabled: !!estimateId,
  });

  return {
    links: query.data || [],
    isLoading: query.isLoading,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
